/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Col,
  Collapse,
  FloatButton,
  Image,
  Input,
  Modal,
  Rate,
  Row,
  Typography,
  //   theme,
} from "antd";
import { MetaTags } from "react-meta-tags";
import {
  CommentOutlined,
  CloseOutlined,
  UploadOutlined,
  UserOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { FaPencil } from "react-icons/fa6";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import useMedia from "use-media-antd-query";
import PropTypes from "prop-types";
import { useHistory, useLocation, withRouter } from "react-router";
import { IoShieldCheckmarkSharp } from "react-icons/io5";
import "react-range-slider-input/dist/style.css";
import "./index.css";
import { areaActivityReview } from "./data";
import { Link } from "react-router-dom";
import WeatherReport from "./weather-report";
import { useDispatch, useSelector } from "react-redux";
import {
  loadAreaActivitiesList,
  loadActivityReviewsList,
  loadSimilarAreaPackagesList,
} from "../../store/activities-list/actions";
import {
  // loadPackagesFaqList,
  loadPackagesFaqMainList,
} from "../../store/packages/actions";
import { SampleNextArrow, SamplePrevArrow } from "../../helpers/utils";
import api from "../../helpers";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import moment from "moment";
// import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import L from "leaflet";
// import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
// import markerIcon from "leaflet/dist/images/marker-icon.png";
// import markerShadow from "leaflet/dist/images/marker-shadow.png";

const SingleActivitiesList = (props) => {
  // delete L.Icon.Default.prototype._getIconUrl;
  // L.Icon.Default.mergeOptions({
  //   iconRetinaUrl: markerIcon2x,
  //   iconUrl: markerIcon,
  //   shadowUrl: markerShadow,
  // });

  // const slider = useRef(null);
  const media = useMedia();
  const dispatch = useDispatch();
  const history = useHistory();

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const activities = JSON.parse(params.get("activities"));
  const area = JSON.parse(params.get("area"));
  const cityList = JSON.parse(params.get("cityList"));

  const activityName =
    props && props.location && activities ? activities.packageName : "";
  const areaActivityName =
    props && props.location && area ? area.activityName : "";
  const activitiesList = props && props.location && area ? area : "";
  const cityListData = props && props.location && cityList ? cityList : "";

  //api call

  useEffect(() => {
    dispatch(loadActivityReviewsList(`?parentId=${activitiesList.areaId}`));
    dispatch(
      loadPackagesFaqMainList(`?destinationId=${activitiesList.areaId}`)
    );
    // dispatch(loadActivityReviewsList(activitiesList.areaId));
    dispatch(
      loadSimilarAreaPackagesList("?destinationId=" + activitiesList.areaId)
    );
    dispatch(loadAreaActivitiesList("?areaId=" + activitiesList.areaId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //reducer state

  const {
    activities_reviews_list = [],
    similar_packages_list = [],
    area_activities_list = [],
  } = useSelector((state) => state.Activities);
  const { packages_faq_main_list = [] } = useSelector(
    (state) => state.Packages
  );

  const activitiesReview =
    activities_reviews_list && activities_reviews_list.queryResult
      ? activities_reviews_list.queryResult
      : "";

  const reviewsArray =
    activitiesReview && activitiesReview.length > 0
      ? activitiesReview.map((data) => {
          return {
            createdAt: data.createdAt,
            createdByName: data.createdByName,
            description: data.description,
            imageUrl: data.imageUrl,
            parentId: data.parentId,
            ratings: data.ratings,
            reviewByName: data.reviewByName,
            reviewDate: data.reviewDate,
            status: data.status,
            type: data.type,
            _id: data._id,
          };
        })
      : [];

  const packageFaqList =
    packages_faq_main_list &&
    packages_faq_main_list.queryResult &&
    packages_faq_main_list.queryResult.length > 0
      ? packages_faq_main_list.queryResult.map((data, index) => {
          return {
            key: index + 1,
            label: data.question,
            children: (
              <p className="text-[12px] text-center font-normal">
                {data.answer !== "" ? data.answer : "No data found.."}
              </p>
            ),
            _id: data._id,
          };
        })
      : [];

  // const MAX_SLIDES = 5;
  const slides =
    similar_packages_list &&
    similar_packages_list.queryResult &&
    similar_packages_list.queryResult.length > 0
      ? similar_packages_list.queryResult.map((data) => {
          return {
            destinationId: data.destinationId,
            itineraries: data.itineraries,
            days:
              data.itineraries.length > 0
                ? data.itineraries.length + " Days"
                : 0,
            nights:
              data.itineraries.length > 0
                ? parseFloat(data.itineraries.length - 1) + " Nights"
                : 0,
            startingFrom: data.lowestPrice
              ? "₹ " + parseFloat(data.lowestPrice + 2000)
              : "",
            imgHeight: 250,
            Price: data.lowestPrice !== null ? "₹ " + data.lowestPrice : "₹ 0",
            packageCategoryId: data.packageCategoryId,
            packageCode: data.packageCode,
            hotels: data.packageIncludes ? data.packageIncludes.hotels : false,
            meals: data.packageIncludes ? data.packageIncludes.meals : false,
            transport: data.packageIncludes
              ? data.packageIncludes.transport
              : false,
            sightSeeing: data.packageIncludes
              ? data.packageIncludes.sightSeeing
              : false,
            packageName: data.packageName,
            imageUrl:
              data.thumbnailsImages && data.thumbnailsImages.length > 0
                ? data.thumbnailsImages[0].imageUrl
                : "",
            Duration: data.tourPlan,
            _id: data._id,
          };
        })
      : [];
  const sliderRef = useRef(null);
  const [slideWidth, setSlideWidth] = useState(0);

  const getSlideWidth = () => {
    if (sliderRef.current) {
      const slickTrack =
        sliderRef.current.innerSlider.list.querySelector(".slick-track");
      const slickSlide = slickTrack?.querySelector(".slick-slide");
      if (slickSlide) {
        const width = slickSlide.getBoundingClientRect().width;
        setSlideWidth(width);
      }
    }
  };
  const settings = {
    // className: "center",
    centerMode: true,
    // dots: true, // Show navigation dots
    infinite: slides && slides.length > 1,
    centerPadding: "3px",
    ref: sliderRef,
    onInit: getSlideWidth, // <-- this triggers on load
    onReInit: getSlideWidth, // <-- also when resized or re-rendered
    afterChange: getSlideWidth, // <-- after sliding
    slidesToShow:
      media == "xxl" && slides && slides.length >= 6
        ? 6
        : media == "xxl" && slides && slides.length < 4
        ? slides.length
        : media == "xl" && slides && slides.length >= 5
        ? 5
        : media == "xl" && slides && slides.length < 4
        ? slides.length
        : media == "lg" && slides && slides.length >= 4
        ? 4
        : media == "lg" && slides && slides.length < 4
        ? slides.length
        : media == "md" && slides && slides.length >= 3
        ? 3
        : media == "md" && slides && slides.length < 4
        ? slides.length
        : media == "sm" && slides && slides.length >= 3
        ? 2
        : media == "sm" && slides && slides.length < 4
        ? slides.length
        : 1,
    // fade: true,
    // speed: 1200,
    // autoplay: true,
    // autoplaySpeed: 2200,
    nextArrow: <SampleNextArrow marginRight="15px" />,
    prevArrow: <SamplePrevArrow marginLeft="15px" />,
    // slidesToScroll: 1,
    // cssEase: "linear",
  };

  const areaData =
    area_activities_list &&
    area_activities_list.data &&
    area_activities_list.data;

  const weatherReports =
    areaData && areaData.weatherReport !== null ? [areaData.weatherReport] : [];
  const activityOverviewDetails =
    areaData && areaData.description && areaData.description;

  const temp = document.createElement("div");
  temp.innerHTML = activityOverviewDetails;

  // Get the plain text only
  const activityOverview = temp.textContent || temp.innerText || "";
  const imageUrl =
    areaData && areaData && areaData.images && areaData.images.length > 0
      ? areaData.images[0].imageUrl
      : "";
  const similarAreaDetails =
    areaData &&
    areaData &&
    areaData.similarAreaData &&
    areaData.similarAreaData.length > 0
      ? areaData.similarAreaData
      : "";

  const activityDetailsList =
    similarAreaDetails && similarAreaDetails.length > 0
      ? similarAreaDetails.map((data) => {
          return {
            activityName: data.areaName,
            imageUrl:
              data.images && data.images.length > 0
                ? data.images[0].imageUrl
                : "",
            // activityCity: "Kochi",
            // activityState: "Kerala",
            destinationId: data.destinationId,
            cityId: data.cityId,
            areaId: data._id,
            lowestPrice: data.lowestPrice,
            // activityName: data.cityName,
            noOfActivities: data.noOfActivities,
            activityCity: cityList.activityName ? cityList.activityName : "",
            activityState: activityName ? activityName : "",

            // imageUrl: data.images && imageUrl !== "" ? imageUrl : "",
          };
        })
      : [];

  //overview
  const [expandedItems, setExpandedItems] = useState(false);

  const toggleText = () => {
    setExpandedItems(!expandedItems);
  };

  const maxLength = 300;

  const [expandedReviewItems, setExpandedReviewItems] = useState({});

  const toggleReviewText = (index) => {
    setExpandedReviewItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const StarRating = ({ rating }) => {
    return (
      <div style={{ fontSize: "24px", color: "#f1c40f" }}>
        {"★".repeat(rating)}
      </div>
    );
  };

  //Review & maps, weather
  const position =
    areaData && areaData.location && areaData.location.coordinates.length > 0
      ? areaData.location.coordinates
      : [];

  // Guruvayur
  const mapSrc = `https://maps.google.com/maps?q=${position[1]},${position[0]}&z=15&output=embed`;
  const [chatModal, setChatModal] = useState(false);
  const [reviewSelected, setReviewSelected] = useState("Reviews");
  const [reviewModal, setReviewModal] = useState(false);

  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [customerName, setCustomerName] = useState("");
  // const [customerMail, setCustomerMail] = useState("");
  const [reviewDescriptions, setReviewDescriptions] = useState("");
  const [ratings, setRatings] = useState("");
  const [reviewValidations, setReviewValidations] = useState(false);
  const [reviewButtonDisabled, setReviewButtonDisabled] = useState(false);
  // const [customerEmailValidations, setCustomerEmailValidations] =
  //   useState(false);

  // //Email validation changes
  // const validationEnquireEmailChange = ({ target: { value: inputValue } }) => {
  //   const mainInput = document.getElementById("main-review-email-input");
  //   const current_value = inputValue.replace(/ /g, "");
  //   setCustomerMail(current_value);

  //   if (!emailIsValid(current_value)) {
  //     document.getElementById("error-review-email-panel").style.display =
  //       "block";
  //     mainInput.value = current_value;
  //     setCustomerEmailValidations(true);
  //   } else {
  //     document.getElementById("error-review-email-panel").style.display =
  //       "none";
  //     setCustomerEmailValidations(false);
  //   }
  // };

  const handleImageChange = (e) => {
    var fileArrayDetails =
      e.target.files && e.target.files.length > 0 ? e.target.files[0] : "";
    // var teamUploadValue = fileList;
    var formData = new FormData();
    formData.append("file", fileArrayDetails);

    setUploading(true);
    setTimeout(() => {
      api
        .post(`/uploads/upload-file`, formData)
        .then(async (res) => {
          if (res && res.data) {
            // teamUploadValue.push(res.data);
            setUploading(false);
            // toast.success("Image Uploaded successfully");
            await setFileList([res.data.datum]);
          }
        })
        .catch((error) => {
          toast.error(
            `${
              !isEmpty(error) && error.response && error.response.data
                ? error.response.data.error
                : ""
            }`
          );
        });
    }, 1000);
  };

  const writeReviewDetails = () => {
    // setPackageTabDetails("Calculate Price");
    if (
      customerName !== "" &&
      // ratings !== "" &&
      reviewDescriptions !== ""
    ) {
      setReviewButtonDisabled(true);
      setTimeout(() => {
        setReviewButtonDisabled(false);
      }, 3000);

      const packages = {
        parentId: activitiesList.areaId,
        description: reviewDescriptions,
        userName: customerName,
        imageUrl: fileList && fileList.length > 0 ? fileList[0] : "",
        ratings: ratings.toString(),
        type: "destination", //['destination','package','itinerary','hotel']
        // emailId: customerMail,
      };
      api
        .post("/review/create", packages)
        .then((res) => {
          toast.success("Review added successfully");
          dispatch(loadActivityReviewsList());
          setTimeout(() => {
            setReviewModal(false);
            setReviewValidations(false);
          }, 1500);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.msg);
          toast.error(
            errorMsg || "There is an issue while calculate the price"
          );
          Promise.reject(error);
        });
    } else {
      setReviewModal(true);
      setReviewValidations(true);
    }
  };

  const similarSettings = {
    // className: "center",
    centerMode: true,
    // dots: true, // Show navigation dots
    infinite: activityDetailsList && activityDetailsList.length > 1,
    centerPadding: "3px",
    ref: sliderRef,
    onInit: getSlideWidth, // <-- this triggers on load
    onReInit: getSlideWidth, // <-- also when resized or re-rendered
    afterChange: getSlideWidth, // <-- after sliding
    slidesToShow:
      media == "xxl" && activityDetailsList && activityDetailsList.length >= 6
        ? 6
        : media == "xxl" &&
          activityDetailsList &&
          activityDetailsList.length < 4
        ? activityDetailsList.length
        : media == "xl" &&
          activityDetailsList &&
          activityDetailsList.length >= 5
        ? 5
        : media == "xl" && activityDetailsList && activityDetailsList.length < 4
        ? activityDetailsList.length
        : media == "lg" &&
          activityDetailsList &&
          activityDetailsList.length >= 4
        ? 4
        : media == "lg" && activityDetailsList && activityDetailsList.length < 4
        ? activityDetailsList.length
        : media == "md" &&
          activityDetailsList &&
          activityDetailsList.length >= 3
        ? 3
        : media == "md" && activityDetailsList && activityDetailsList.length < 4
        ? activityDetailsList.length
        : media == "sm" &&
          activityDetailsList &&
          activityDetailsList.length >= 3
        ? 2
        : media == "sm" && activityDetailsList && activityDetailsList.length < 4
        ? activityDetailsList.length
        : 1,
    // fade: true,
    // speed: 1200,
    // autoplay: true,
    // autoplaySpeed: 2200,
    nextArrow: <SampleNextArrow marginRight="15px" marginTop="-35px" />,
    prevArrow: <SamplePrevArrow marginLeft="15px" marginTop="-35px" />,
    // slidesToScroll: 1,
    // cssEase: "linear",
  };
  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>
            {cityList && cityList.activityName + " to " + areaActivityName} |
            Plan mi trip
          </title>
        </MetaTags>
      </div>
      <Col
        md={24}
        sm={24}
        lg={24}
        xl={24}
        xxl={24}
        className="mr-[-6px] mt-[-20px]"
      >
        <Row
          className={
            media == "sm"
              ? "pr-[6%] pl-[6%] "
              : media == "xs"
              ? "pl-[30px]"
              : media == "md"
              ? "pr-[7%] pl-[7%]"
              : media == "lg"
              ? "pr-[10%] pl-[10%]"
              : media == "xxl"
              ? "pr-[11%] pl-[11%]"
              : "pr-[6.5%] pl-[6.5%]"
          }
        >
          <Col
            sm={24}
            xs={24}
            md={24}
            lg={24}
            xl={24}
            xxl={24}
            className={
              media === "md" || media === "sm" || media === "xs"
                ? "mt-7"
                : media === "lg"
                ? "mt-[70px]"
                : "mt-4"
            }
          >
            <div className="flex">
              <Link
                to={{
                  pathname: "/",
                }}
                className="input-label font-semibold text-[#2b2a2a73] hover:bg-[lightgray] px-1 rounded-md hover:text-[black] text-[12px] mr-1"
              >
                Home
              </Link>
              <p className="mr-1 mt-[-3px] text-[#2b2a2a73] font-semibold">/</p>
              <Link
                to={{
                  pathname: "/destinations",
                }}
                className="input-label font-semibold text-[#2b2a2a73] hover:bg-[lightgray] px-1 rounded-md hover:text-[black] text-[12px]"
              >
                Destinations
              </Link>
              <p className="mt-[-3px] text-[#2b2a2a73] font-semibold">/</p>
              <Link
                to={{
                  pathname: `/destinations/destination-in-${activityName}`,
                  state: activities,
                }}
                className="input-label font-semibold text-[#2b2a2a73] hover:bg-[lightgray] px-1 rounded-md hover:text-[black] text-[11px]"
              >
                {activityName}
              </Link>
              <p className="mt-[-3px] text-[#2b2a2a73] font-semibold">/</p>
              <Link
                to={{
                  pathname: `/destinations/destination-in-${activityName}/${cityList.activityName}`,
                  state: { activities: activities, cityData: cityListData },
                }}
                className="input-label font-semibold text-[#2b2a2a73] hover:bg-[lightgray] px-1 rounded-md hover:text-[black] text-[11px]"
              >
                {cityList && cityList.activityName}
              </Link>
              <p className=" mt-[-3px] text-[#2b2a2a73] font-semibold">/</p>
              <p className="input-label font-semibold text-[#eb3e43] px-1 text-[11px]">
                Places to Visit in {cityList && cityList.activityName}
              </p>
              <p className=" mt-[-3px] text-[#2b2a2a73] font-semibold">/</p>
              <p className="input-label font-semibold text-[#eb3e43] px-1 text-[11px]">
                {areaActivityName}
              </p>
            </div>
          </Col>
          <Col sm={24} xs={24} md={24} lg={24} xl={24} xxl={24}>
            <Row>
              <Col
                sm={24}
                xs={24}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                className="mt-[20px]"
              >
                <div className="w-[100%] text-start pr-8">
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="font-black text-[28px]"
                  >
                    {activitiesList.activityName}
                  </h1>
                  {/* <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="font-normal text-[18px]"
                  >
                    {"Check out must-see sights and activities:"}
                  </h1> */}
                </div>
                <div className="w-[100%] flex mt-2 text-start mb-4">
                  <FaPencil className="mr-1 mt-1" />
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    onClick={() =>
                      document.getElementById("reviews").scrollIntoView()
                    }
                    className="cursor-pointer font-normal text-[14px] underline"
                  >
                    {"Write Review"}
                  </h1>
                </div>
              </Col>
              <Col sm={24} xs={24} md={24} lg={24} xl={24} xxl={24}>
                <Row className="w-[100%] rounded-md">
                  <Col
                    sm={24}
                    xs={24}
                    md={16}
                    lg={16}
                    xl={16}
                    xxl={16}
                    className="relative"
                  >
                    <Image
                      // src={activitiesList.imageUrl}
                      src={imageUrl}
                      preview={false}
                      width={"100%"}
                      height={"400px"}
                      className="rounded-2xl object-cover hover:scale-105 transition-transform duration-300 text-start relative cursor-pointer mb-3"
                      // className="w-full object-cover rounded-tl-2xl rounded-bl-2xl hover:scale-105 transition-transform duration-300 text-start relative cursor-pointer mb-3"
                    />
                    <div className="cursor-pointer absolute rounded-tl-2xl rounded-bl-2xl inset-0 bg-[lightgray] bg-opacity-5 hover:bg-opacity-15 transition-colors duration-300"></div>
                  </Col>
                  <Col
                    sm={24}
                    xs={24}
                    md={8}
                    lg={8}
                    xl={8}
                    xxl={8}
                    className="mb-5 pl-4"
                  >
                    <h1 className="input-label font-black text-[18px] border border-b-1 border-x-0 border-t-0 pb-2 mb-5">
                      Location
                    </h1>
                    <div className="input-label border border-1 shadow-sm p-4 w-[100%]">
                      <div className="w-full h-[310px] rounded-md overflow-hidden shadow">
                        <iframe
                          title="Area Map"
                          src={mapSrc ? mapSrc : ""}
                          width="100%"
                          height="100%"
                          style={{ border: 0 }}
                          allowFullScreen=""
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                      </div>
                      {/* <div className="w-full h-64 rounded-md overflow-hidden shadow-lg">
                            <MapContainer
                              center={position}
                              zoom={13}
                              scrollWheelZoom={false}
                              style={{ height: "100%", width: "100%" }}
                            >
                              <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                              />
                              <Marker position={position}>
                                <Popup>{"Guruvayur"}</Popup>
                               <Popup>{areaActivityName ? areaActivityName : "Guruvayor"}</Popup>
                              </Marker>
                            </MapContainer>
                          </div> */}
                    </div>
                  </Col>
                  {/* <Col
                    sm={24}
                    xs={24}
                    md={8}
                    lg={8}
                    xl={8}
                    xxl={8}
                    className="pl-1"
                  >
                    <Row>
                      <Col
                        sm={24}
                        xs={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        className="relative"
                      >
                        <Image
                          // src={activitiesList.imageUrl}
                          src={activity2}
                          preview={false}
                          width={"100%"}
                          height={190}
                          className="w-full object-cover rounded-tr-2xl hover:scale-105 transition-transform duration-300 text-start relative cursor-pointer mb-3"
                        />
                        <div className="cursor-pointer absolute rounded-tr-2xl inset-0 bg-[lightgray] bg-opacity-5 h-[190px] hover:bg-opacity-15 transition-colors duration-300"></div>
                      </Col>
                      <Col
                        className="relative"
                        sm={24}
                        xs={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                      >
                        <Image
                          // src={activitiesList.imageUrl}
                          src={activity3}
                          preview={false}
                          width={"100%"}
                          height={190}
                          className="w-full object-cover rounded-br-2xl hover:scale-105 transition-transform duration-300 text-start relative cursor-pointer mb-3"
                        />
                        <div className="cursor-pointer absolute rounded-br-2xl inset-0 bg-[lightgray] bg-opacity-5 h-[190px] hover:bg-opacity-15 transition-colors duration-300"></div>
                      </Col>
                    </Row>
                  </Col> */}
                </Row>
              </Col>
              <Col sm={24} xs={24} md={24} lg={24} xl={24} xxl={24}>
                <Row className="w-[100%] mt-[40px]">
                  <Col sm={24} xs={24} md={16} lg={16} xl={16} xxl={16}>
                    <Row>
                      <Col
                        sm={24}
                        xs={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        className={
                          media == "sm" || media == "xs" ? "" : "pr-[50px]"
                        }
                      >
                        <h1 className="input-label font-black text-[18px] mb-3">
                          Overview
                        </h1>
                        <div className="input-label w-full">
                          {expandedItems
                            ? activityOverview
                            : `${activityOverview.slice(0, maxLength)}...`}
                          {activityOverview.length > maxLength && (
                            <button
                              onClick={() => toggleText()}
                              style={{
                                marginLeft: "5px",
                                color: "#eb3a3e",
                                border: "none",
                                background: "none",
                                fontSize: "12px",
                                cursor: "pointer",
                                fontFamily: "Poppins",
                              }}
                            >
                              {expandedItems ? "View less" : "View more"}
                            </button>
                          )}
                        </div>
                      </Col>

                      <Col
                        sm={24}
                        xs={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        className={
                          media == "sm" || media == "xs" ? "" : "pr-[50px]"
                        }
                      >
                        <Row className="w-[100%] rounded-md mt-[40px]">
                          {areaActivityReview.map((data, index) => {
                            return (
                              <div
                                key={index}
                                onClick={() => {
                                  setReviewSelected(data.label);
                                }}
                                className={
                                  reviewSelected === data.label
                                    ? "cursor-pointer mr-6 input-label font-semibold text-[20px] pb-1 border border-black border-b-2 border-t-0 border-x-0"
                                    : "cursor-pointer mr-6 input-label font-semibold text-[20px] pb-1"
                                }
                              >
                                <div className="w-[100%]">{data.label}</div>
                              </div>
                            );
                          })}
                        </Row>
                        <Row>
                          <Col
                            sm={24}
                            xs={24}
                            md={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            className="flex justify-center mt-[40px]"
                          >
                            {reviewSelected === "Q & A" ? (
                              <Row className="w-[100%]">
                                {packageFaqList && packageFaqList.length > 0 ? (
                                  <Col
                                    md={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                    className="mt-[20px]"
                                  >
                                    <Row>
                                      <Col
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        sm={24}
                                        xs={24}
                                        className="pr-5 pt-3 pb-3"
                                      >
                                        <div
                                          style={{
                                            fontFamily: "Poppins",
                                            marginBottom: "1.5rem",
                                            //   boxShadow: "1px 1px 1px 2px lightgray",
                                          }}
                                        >
                                          <div className="flex text-[18px] font-extrabold text-start ">
                                            <h2 className="">
                                              Frequently Asked Questions(FAQ)
                                            </h2>
                                            {/* <span className="ml-1">of Booking With Us</span> */}
                                          </div>
                                        </div>
                                      </Col>
                                      <Col
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        sm={24}
                                        xs={24}
                                        className="pr-5 pb-3"
                                      >
                                        <Collapse
                                          items={packageFaqList}
                                          expandIcon={<DownOutlined />}
                                          expandIconPosition="right"
                                          className="font-semibold text-[16px] border-none"
                                          style={{
                                            fontFamily: "Poppins",
                                            background: "none",
                                          }}
                                          //   bordered
                                          bordered={false}
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                ) : (
                                  <h1 className="input-label w-[100%] font-semibold text-[16px] text-center">
                                    No Q & A for this destinations
                                  </h1>
                                )}
                              </Row>
                            ) : (
                              <Row className="w-[100%]">
                                {reviewsArray && reviewsArray.length > 0 ? (
                                  reviewsArray.map((data, index) => {
                                    const maxReviewLength = 140;
                                    return (
                                      <Col
                                        sm={24}
                                        xs={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        className="mb-3 p-5 border border-1 rounded-xl bg-[white]"
                                      >
                                        <div className="flex">
                                          <div className="flex">
                                            <Avatar
                                              className="bg-[#c7c7c740]"
                                              size={"default"}
                                              shape="circle"
                                            >
                                              <UserOutlined className="text-lg text-[#eb3a3e]" />
                                            </Avatar>
                                            <div className="input-label ml-2 mt-1 text-md font-bold text-gray-900">
                                              {data.reviewByName}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="mt-2">
                                          <StarRating rating={data.ratings} />
                                        </div>
                                        <div
                                          style={{
                                            fontFamily: "Poppins",
                                            //   boxShadow: "1px 1px 1px 2px lightgray",
                                          }}
                                          className="cursor-pointer mt-5 text-[14px] mb-[10px] bg-white"
                                        >
                                          {expandedReviewItems[index]
                                            ? data.description
                                            : `${data.description.slice(
                                                0,
                                                maxReviewLength
                                              )}...`}
                                          {data.description.length >
                                            maxReviewLength && (
                                            <button
                                              onClick={() =>
                                                toggleReviewText(index)
                                              }
                                              style={{
                                                marginLeft: "5px",
                                                color: "#eb3a3e",
                                                border: "none",
                                                background: "none",
                                                fontSize: "12px",
                                                cursor: "pointer",
                                                fontFamily: "Poppins",
                                              }}
                                            >
                                              {expandedReviewItems[index]
                                                ? "View less"
                                                : "View more"}
                                            </button>
                                          )}
                                        </div>

                                        <div className="input-label text-[12px] mr-1 text-gray-900">
                                          {`Written ${
                                            data.reviewDate &&
                                            moment(data.reviewDate).format(
                                              "DD MMMM YYYY"
                                            )
                                          }`}
                                        </div>
                                      </Col>
                                    );
                                  })
                                ) : (
                                  <h1 className="input-label font-semibold text-[20px]">
                                    No reviews yet. Be the first to share your
                                    thoughts!
                                  </h1>
                                )}
                              </Row>
                            )}
                          </Col>
                          <Col
                            sm={24}
                            xs={24}
                            md={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            id="reviews"
                            className="p-6 "
                          >
                            <div className="flex justify-center w-[100%] mt-4">
                              <div
                                className={
                                  media == "sm" || media == "xs"
                                    ? "bg-[#eb3e43] p-3 hover:bg-[red] text-[14px] ml-3 mt-1"
                                    : "bg-[#eb3e43] p-3 hover:bg-[red] text-[16px] ml-2 mt-1"
                                }
                                style={{
                                  borderRadius: "22px",
                                  fontFamily: "Poppins",
                                  fontWweight: 800,
                                  color: "white",
                                  cursor: "pointer",
                                  marginTop: "3px",
                                  zIndex: 20,
                                }}
                                onClick={() => {
                                  setReviewModal(true);
                                  setCustomerName("");
                                  setReviewDescriptions("");
                                  setRatings("");
                                  setFileList([]);
                                }}
                              >
                                Write Review
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  {/* Overviews */}
                  <Col sm={24} xs={24} md={8} lg={8} xl={8} xxl={8}>
                    <Row className="w-[100%]">
                      {/* <Col
                        sm={24}
                        xs={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        className="mb-5"
                      >
                        <h1 className="input-label font-black text-[18px] border border-b-1 border-x-0 border-t-0 pb-2 mb-5">
                          Location
                        </h1>
                        <div className="input-label border border-1 shadow-sm p-4 w-[100%]">
                          <div className="w-full h-64 rounded-md overflow-hidden shadow">
                            <iframe
                              title="Area Map"
                              src={mapSrc}
                              width="100%"
                              height="100%"
                              style={{ border: 0 }}
                              allowFullScreen=""
                              loading="lazy"
                              referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                          </div>
                          {/* <div className="w-full h-64 rounded-md overflow-hidden shadow-lg">
                            <MapContainer
                              center={position}
                              zoom={13}
                              scrollWheelZoom={false}
                              style={{ height: "100%", width: "100%" }}
                            >
                              <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                              />
                              <Marker position={position}>
                                <Popup>{"Guruvayur"}</Popup>
                               <Popup>{areaActivityName ? areaActivityName : "Guruvayor"}</Popup>
                              </Marker>
                            </MapContainer>
                         
                        </div>
                      </Col> */}
                      <Col
                        sm={24}
                        xs={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        className="mb-5 pl-5"
                      >
                        <h1 className="input-label font-black text-[18px] border border-b-1 border-x-0 border-t-0 pb-2 mb-5">
                          Weather
                        </h1>
                        <WeatherReport
                          areaName={areaActivityName}
                          areaData={weatherReports}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col
                sm={24}
                xs={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                className={
                  media == "sm" || media == "xs"
                    ? "mt-[40px] border border-b-1 border-t-0 border-x-0 pb-8"
                    : "mt-[40px] border border-b-1 border-t-0 border-x-0 pb-8"
                }
              >
                <div className="w-[100%] text-start pr-8">
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="font-black text-[20px] mb-1"
                  >
                    {`Similar destinations`}
                  </h1>
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="font-normal text-[14px] mb-4"
                  >
                    {"Tours and Destinations tailored to your interests."}
                  </h1>
                </div>
                {/* <Row className="flex flex-row"> */}
                {activityDetailsList && activityDetailsList.length > 0 ? (
                  <Slider {...similarSettings} centerMode className="h-[100%]">
                    {activityDetailsList.map((data, index) => {
                      return (
                        <Link
                          to={`/destinations/destination-in-${activityName}/${
                            data.activityCity
                          }/Places to Visit in ${data.activityCity}/${
                            data.activityName
                          }?activities=${encodeURIComponent(
                            JSON.stringify(activities)
                          )}&cityList=${encodeURIComponent(
                            JSON.stringify(cityListData)
                          )}&area=${encodeURIComponent(JSON.stringify(data))}`}
                          target="_blank"
                        >
                          <div
                            style={{
                              fontFamily: "Poppins",
                            }}
                            key={index}
                            className="cursor-pointer h-[280px] pr-2 pl-2"
                          >
                            <Image
                              src={data.imageUrl}
                              preview={false}
                              height={280}
                              width={"100%"}
                              className="w-full object-cover rounded-2xl group-hover:scale-105 transition-transform duration-300 text-start relative cursor-pointer mb-3"
                            />
                            {/* <div className="cursor-pointer w-[70%] absolute rounded-tl-2xl rounded-bl-2xl inset-0 bg-[lightgray] bg-opacity-5 h-[250px] hover:bg-opacity-15 transition-colors duration-300"></div> */}
                            <div className="w-[100%] z-10">
                              <p
                                style={{
                                  position: "absolute",
                                  top: "0px",
                                  bottom: "5px",
                                  color: "#ffffff",
                                  width:
                                    slideWidth && parseFloat(slideWidth - 17),
                                  background: "#0000002b",
                                  fontSize: "18px",
                                  fontFamily: "Poppins",
                                  fontWeight: 700,
                                  padding: "10px",
                                  borderRadius: "14px",
                                }}
                              >
                                {data.activityName}
                              </p>
                              <div
                                style={{
                                  position: "absolute",
                                  bottom: "5px",
                                  marginLeft: "1px",
                                  color: "#f1f1f1ed",
                                  fontSize: "14px",
                                  fontWeight: 700,
                                  zIndex: 20,
                                  padding: "20px 20px",
                                }}
                              >
                                <h1
                                  style={
                                    {
                                      // display: "flex",
                                      // flexDirection:
                                      //   media == "lg" ||
                                      //   media == "md" ||
                                      //   media == "sm" ||
                                      //   media == "xs"
                                      //     ? "column"
                                      //     : "row",
                                    }
                                  }
                                >
                                  {/* <div className="text-[16px] group-hover:opacity-0 transition-opacity font-semibold">
                                    {data.activityName}
                                  </div> */}
                                  <div className="text-[13px] group-hover:opacity-0 transition-opacity font-normal">
                                    {data.activityState + ", India"}
                                  </div>
                                </h1>
                              </div>
                            </div>
                          </div>
                        </Link>
                      );
                    })}
                  </Slider>
                ) : (
                  <div className="text-center images-label">
                    No Destinations found
                  </div>
                )}
                {/* {activityDetailsList.map((data, index) => {
                  return (
                    <Col
                      md={12}
                      lg={6}
                      xl={6}
                      xxl={6}
                      sm={24}
                      xs={24}
                      className={
                        media !== "md" || media !== "sm" || media !== "xs"
                          ? "pr-5 pb-3 cursor-pointer"
                          : index == 5
                          ? "pr-5 pb-3 cursor-pointer"
                          : "pr-5 pb-3 cursor-pointer"
                      }
                      // onClick={() =>
                      //   history.push({
                      //     pathname: `/activities/activity-in-${data.packageName}`,
                      //     state: data,
                      //   })
                      // }
                    >
                      <Link
                        to={`/activities/activity-in-${activityName}/${
                          data.activityCity
                        }/Places to Visit in ${data.activityCity}/${
                          data.activityName
                        }?activities=${encodeURIComponent(
                          JSON.stringify(activities)
                        )}&cityList=${encodeURIComponent(
                          JSON.stringify(cityListData)
                        )}&area=${encodeURIComponent(JSON.stringify(data))}`}
                        target="_blank"
                      >
                        <div
                          style={{
                            fontFamily: "Poppins",
                            // border: "1px solid rgba(200, 203, 206, 0.81)",
                          }}
                          className="group h-[280px] relative rounded-2xl overflow-hidden shadow-lg cursor-pointer"
                          key={index}
                        >
                          <Image
                            //   src={data.imageUrl}
                            src={data.imageUrl}
                            preview={false}
                            height={280}
                            width={"100%"}
                            className="w-full object-cover rounded-2xl group-hover:scale-105 transition-transform duration-300 text-start relative cursor-pointer mb-3"
                          />
                          <div className="absolute inset-0 bg-black bg-opacity-10 group-hover:bg-opacity-50 transition-colors duration-300"></div>
                          <div className="absolute top-20 left-7 right-5 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                            <div className="flex items-center justify-between">
                              <div className="text-white">
                                <p className="text-sm">Discover</p>
                                <p className="text-sm">Activities In</p>
                                <h2 className="text-lg font-semibold">
                                  {data.activityName}
                                </h2>
                              </div>
                              <div className="bg-[#eb3e43] text-white w-8 h-8 rounded-full flex items-center justify-center transition-transform duration-300">
                                →
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="mt-3 font-semibold"
                        >
                          <div className="text-[16px] group-hover:opacity-0 transition-opacity font-semibold">
                            {data.activityName}
                          </div>
                          <div className="text-[13px] group-hover:opacity-0 transition-opacity font-normal">
                            {data.activityState + ", India"}
                          </div>
                        </div>
                      </Link>
                    </Col>
                  );
                })} */}
                {/* </Row> */}
              </Col>
              <Col
                sm={24}
                xs={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                className={
                  media == "sm" || media == "xs"
                    ? "mt-[40px] border border-b-1 border-t-0 border-x-0 pb-8"
                    : "mt-[40px] border border-b-1 border-t-0 border-x-0 pb-8"
                }
              >
                <div className="w-[100%] text-start pr-8">
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="font-black text-[20px] mb-2"
                  >
                    {`More Packages to Explore`}
                  </h1>
                  {/* <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="font-normal text-[14px] mb-2"
                  >
                    {"Tours and activities tailored to your interests."}
                  </h1> */}
                </div>
                <div
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className="mt-5"
                >
                  {slides && slides.length < 4 ? (
                    slides.map((slide, index) => {
                      return (
                        <div
                          key={index}
                          onClick={() => {
                            history.push({
                              pathname: `/package-details/${slide._id}`,
                              state: slide,
                            });
                          }}
                          className="cursor-pointer h-[260px] pr-2 pl-2"
                        >
                          <Image
                            preview={false}
                            alt="no-img"
                            src={slide.imageUrl}
                            width={
                              media === "md"
                                ? "27%"
                                : media === "sm" || media === "xs"
                                ? "25%"
                                : "24%"
                            }
                            className="border border-solid cursor-pointer relative rounded-md"
                            height={270}
                          />
                          {/* <div className="cursor-pointer w-[70%] absolute rounded-tl-2xl rounded-bl-2xl inset-0 bg-[lightgray] bg-opacity-5 h-[250px] hover:bg-opacity-15 transition-colors duration-300"></div> */}
                          <div className="w-[100%] z-10">
                            <p
                              style={{
                                position: "absolute",
                                top: "50px",
                                bottom: "20px",
                                color: "#ffffff",
                                width:
                                  media === "md"
                                    ? "26.5%"
                                    : media === "sm" || media === "xs"
                                    ? "24.5%"
                                    : "23.5%",
                                background: "#0000002b",
                                fontSize: "18px",
                                fontFamily: "Poppins",
                                fontWeight: 700,
                                padding: "20px",
                                borderRadius: "8px",
                              }}
                            >
                              {slide.packageName}
                            </p>
                            <div
                              style={{
                                position: "absolute",
                                bottom: "10px",
                                marginLeft: "1px",
                                color: "#f1f1f1ed",
                                fontSize: "14px",
                                fontWeight: 700,
                                zIndex: 20,
                                padding: "20px 20px",
                              }}
                            >
                              <h1
                                style={{
                                  display: "flex",
                                  flexDirection:
                                    media == "lg" ||
                                    media == "md" ||
                                    media == "sm" ||
                                    media == "xs"
                                      ? "column"
                                      : "row",
                                }}
                              >
                                <p
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  Starting at
                                </p>
                                <p className="flex ml-2">
                                  <p
                                    className=""
                                    style={{
                                      // fontFamily: "Poppins",
                                      fontWeight: 800,
                                      fontSize: "14px",
                                      marginTop: "2px",
                                    }}
                                  >
                                    {slide.Price}
                                  </p>
                                </p>
                              </h1>
                              <div
                                style={{
                                  fontFamily: "Poppins",
                                  marginTop: "-2px",
                                }}
                              >
                                Per Person
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : slides && slides.length > 3 ? (
                    <Slider {...settings} centerMode className="h-[100%]">
                      {slides.map((slide, index) => {
                        return (
                          <div
                            key={index}
                            onClick={() => {
                              history.push({
                                pathname: `/package-details/${slide._id}`,
                                state: slide,
                              });
                            }}
                            className="cursor-pointer h-[250px] pr-2 pl-2"
                          >
                            <Image
                              preview={false}
                              alt="no-img"
                              src={slide.imageUrl}
                              width={"100%"}
                              className="border border-solid cursor-pointer relative rounded-md"
                              height={slide.imgHeight}
                            />
                            {/* <div className="cursor-pointer w-[70%] absolute rounded-tl-2xl rounded-bl-2xl inset-0 bg-[lightgray] bg-opacity-5 h-[250px] hover:bg-opacity-15 transition-colors duration-300"></div> */}
                            <div className="w-[100%] z-10">
                              <p
                                style={{
                                  position: "absolute",
                                  top: "0px",
                                  bottom: "5px",
                                  color: "#ffffff",
                                  width:
                                    slideWidth && parseFloat(slideWidth - 18),
                                  background: "#0000002b",
                                  fontSize: "18px",
                                  fontFamily: "Poppins",
                                  fontWeight: 700,
                                  padding: "20px",
                                  borderRadius: "8px",
                                }}
                              >
                                {slide.packageName}
                              </p>
                              <div
                                style={{
                                  position: "absolute",
                                  bottom: "5px",
                                  marginLeft: "1px",
                                  color: "#f1f1f1ed",
                                  fontSize: "14px",
                                  fontWeight: 700,
                                  zIndex: 20,
                                  padding: "20px 20px",
                                }}
                              >
                                <h1
                                  style={{
                                    display: "flex",
                                    flexDirection:
                                      media == "lg" ||
                                      media == "md" ||
                                      media == "sm" ||
                                      media == "xs"
                                        ? "column"
                                        : "row",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                  >
                                    Starting at
                                  </p>
                                  <p className="flex ml-2">
                                    <p
                                      className=""
                                      style={{
                                        // fontFamily: "Poppins",
                                        fontWeight: 800,
                                        fontSize: "14px",
                                        marginTop: "2px",
                                      }}
                                    >
                                      {slide.Price}
                                    </p>
                                  </p>
                                </h1>
                                <div
                                  style={{
                                    fontFamily: "Poppins",
                                    marginTop: "-2px",
                                  }}
                                >
                                  Per Person
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </Slider>
                  ) : (
                    <div className="text-center images-label">
                      No Packages found
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Modal
          open={reviewModal}
          // title="Want to Go For A Memorable Holiday?"
          maskClosable={false}
          onClose={() => setReviewModal(false)}
          closable
          onCancel={() => setReviewModal(false)}
          footer={null}
          className="package-fonts p-3 mt-[-80px]"
          closeIcon
          width={500}
        >
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <Row>
              <Col
                md={24}
                sm={24}
                lg={24}
                xl={24}
                xxl={24}
                className="package-fonts text-[20px] font-semibold"
              >
                Write Your Review
              </Col>
            </Row>
            <Row>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                className="mt-2"
              >
                <Typography className="package-fonts text-[14px] mb-2">
                  Name
                </Typography>
                <Input
                  name="customerName"
                  value={customerName}
                  style={{
                    height: "40px",
                    fontFamily: "Poppins",
                  }}
                  onChange={(e) => setCustomerName(e.target.value)}
                  placeholder="Your Name"
                  className="text-[14px] package-fonts"
                />
                <p
                  style={{
                    display: "inline-block",
                  }}
                  className="text-start input-label text-[#ff0000] mt-2 text-[11px]"
                >
                  {reviewValidations === true && customerName === ""
                    ? "Name field is required"
                    : ""}
                </p>
              </Col>
              {/* <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className="mt-2 pl-3"
                >
                  <Typography className="package-fonts text-[14px] mb-2">
                    Mobile
                  </Typography>
                  <Input
                    name="customerMobile"
                    value={customerMobile}
                    id="main-enquire-input"
                    onChange={validationEnquireChange}
                    style={{
                      height: "40px",
                      fontFamily: "Poppins",
                    }}
                    maxLength={10}
                    placeholder="Your Mobile"
                    className="package-fonts text-[14px]"
                    suffix={<FaMobile className="text-[14px] text-[#818181]" />}
                  />
                  <div id="error-enquire-panel">
                    {customerMobileValidations == true ? (
                      <p className="input-label text-[11px] text-start text-[#ff0000]">
                        The mobile field is not valid
                      </p>
                    ) : (
                      <p
                        style={{
                          display: "inline-block",
                        }}
                        className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                      >
                        {enquireValidations === true && customerMobile === ""
                          ? "Customer mobile field is required"
                          : ""}
                      </p>
                    )}
                  </div>
                </Col> */}
              {/* <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                className="mt-2"
              >
                <Typography className="package-fonts text-[14px] mb-2">
                  Email ID
                </Typography>
                <Input
                  name="customerMail"
                  value={customerMail}
                  style={{
                    height: "40px",
                    fontFamily: "Poppins",
                  }}
                  onChange={validationEnquireEmailChange}
                  placeholder="Your Email ID"
                  id="main-review-email-input"
                  className="package-fonts text-[14px]"
                />
                <div id="error-review-email-panel">
                  {customerEmailValidations == true ? (
                    <p className="input-label text-[11px] text-start text-[#ff0000]">
                      The email field is not valid
                    </p>
                  ) : (
                    <p
                      style={{
                        display: "inline-block",
                      }}
                      className="text-start input-label text-[#ff0000] mt-2 text-[11px]"
                    >
                      {reviewValidations === true && customerMail === ""
                        ? "Mail field is required"
                        : ""}
                    </p>
                  )}
                </div>
              </Col> */}
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                className="mt-2 mb-2"
              >
                <Typography className="package-fonts text-[14px] mb-2">
                  Review
                </Typography>
                <Input.TextArea
                  name="reviewDescriptions"
                  value={reviewDescriptions}
                  style={{
                    height: "100px",
                    fontFamily: "Poppins",
                  }}
                  onChange={(e) => setReviewDescriptions(e.target.value)}
                  placeholder="Write your review"
                  className="package-fonts text-[14px]"
                />
                <p
                  style={{
                    display: "inline-block",
                  }}
                  className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                >
                  {reviewValidations === true && reviewDescriptions === ""
                    ? "Review field is required"
                    : ""}
                </p>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                className="mt-2 mb-2"
              >
                <Typography className="package-fonts text-[14px] mb-2">
                  Ratings
                </Typography>
                <Rate
                  name="ratings"
                  value={ratings}
                  style={{
                    fontFamily: "Poppins",
                  }}
                  count={5}
                  onChange={(e) => {
                    setRatings(e);
                  }}
                  className="package-fonts text-[25px]"
                />
                {/* <p
                  style={{
                    display: "inline-block",
                  }}
                  className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                >
                  {reviewValidations === true && ratings === ""
                    ? "ratings field is required"
                    : ""}
                </p> */}
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                className="mt-2 mb-1"
              >
                <Typography className="package-fonts text-[14px] mb-2">
                  Upload Photo
                </Typography>
                <div
                  className={
                    media == "sm" || media == "xs"
                      ? "w-[150px] text-center bg-[white] p-1 text-[#eb3e43] hover:text-[white] hover:bg-[#eb3e43] text-[14px] ml-3 mt-1"
                      : "w-[150px] text-center bg-[white] p-1 text-[#eb3e43] hover:text-[white] hover:bg-[#eb3e43] text-[16px] ml-2 mt-1"
                  }
                  style={{
                    borderRadius: "22px",
                    fontFamily: "Poppins",
                    border: "1px solid #eb3e43",
                    fontWeight: 500,
                    cursor: "pointer",
                    marginTop: "3px",
                    zIndex: 20,
                  }}
                >
                  {uploading ? (
                    "...uploading"
                  ) : (
                    <label
                      htmlFor="file-upload"
                      className="flex cursor-pointer text-center pl-4"
                    >
                      <UploadOutlined className="mr-2" /> Upload
                    </label>
                  )}
                  <Input
                    id="file-upload"
                    name="fileList"
                    // value={fileList}
                    onChange={(e) => handleImageChange(e)}
                    type="file"
                    className="input-label"
                  />
                </div>
                {fileList && fileList.length > 0 ? (
                  <p
                    onClick={() => window.open(fileList[0], "_blank")}
                    className="mt-2 input-label text-[10px] underline text-[#eb3e43]"
                  >
                    {fileList[0]}
                  </p>
                ) : (
                  ""
                )}
              </Col>
            </Row>
            <Row className="mt-6">
              <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                <div
                  style={{
                    borderRadius: "22px",
                    pointerEvents: reviewButtonDisabled ? "none" : "",
                    opacity: reviewButtonDisabled ? 1 : "",
                  }}
                  onClick={() => {
                    writeReviewDetails();
                  }}
                  className="w-[100%] cursor-pointer p-1 package-fonts text-center text-[16px] bg-[#eb3e43] text-[white]"
                >
                  Submit Review
                </div>
              </Col>
            </Row>
          </Col>
        </Modal>
        <Modal
          open={chatModal}
          title=""
          maskClosable={false}
          onClose={() => setChatModal(false)}
          closable
          footer={null}
          closeIcon={
            <CloseOutlined
              onClick={() => setChatModal(false)}
              className="text-[#ffffff]"
            />
          }
          width={600}
        >
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <div className="w-[107%] ml-[-20px] mt-[-16px] h-[200px] global-modal-img rounded-md">
              <Row>
                <Col
                  style={{
                    fontFamily: "Poppins",
                  }}
                  md={12}
                  sm={12}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className="p-3"
                >
                  <h2 className="text-[#ffffff]">
                    Don't miss out on our exclusive deals & insider only offers!
                  </h2>
                  <div className="text-[#ffffff] mt-2">
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      5 years of Experience in India
                    </div>
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      Packages across 50 + Countries
                    </div>
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      Best Travel Partner of India
                    </div>
                  </div>
                </Col>
                <Col md={12} sm={12} lg={12} xl={12} xxl={12}></Col>
              </Row>
            </div>
          </Col>
        </Modal>
        <FloatButton
          className="w-[50px] h-[50px]"
          type="primary"
          style={{
            margin: "-7px",
          }}
          onClick={() => setChatModal(!chatModal)}
          icon={<CommentOutlined />}
        />
      </Col>
    </React.Fragment>
  );
};

SingleActivitiesList.propTypes = {
  location: PropTypes.any,
};

export default withRouter(SingleActivitiesList);
